/** 后台侧边栏分组配置（path 与 router 保持一致） */
export const MENU_GROUPS = [
  {
    key: 'overview',
    title: '概览',
    icon: 'el-icon-data-analysis',
    items: [{ path: '/dashboard', title: '数据概览', icon: 'el-icon-data-analysis' }]
  },
  {
    key: 'user',
    title: '用户与代理',
    icon: 'el-icon-user-solid',
    items: [
      { path: '/users', title: '用户管理', icon: 'el-icon-user' },
      { path: '/agent-applications', title: '代理审核', icon: 'el-icon-s-check' },
      { path: '/commissions', title: '佣金审核', icon: 'el-icon-coin' },
      { path: '/withdrawals', title: '提现审核', icon: 'el-icon-money' },
      { path: '/agent-settings', title: '代理文案', icon: 'el-icon-edit' }
    ]
  },
  {
    key: 'plan',
    title: '方案与订单',
    icon: 'el-icon-document',
    items: [
      { path: '/plans', title: '方案管理', icon: 'el-icon-document' },
      { path: '/plan-algorithm', title: '方案算法', icon: 'el-icon-cpu' },
      { path: '/orders', title: '订单管理', icon: 'el-icon-s-order' }
    ]
  },
  {
    key: 'finance',
    title: '财务管理',
    icon: 'el-icon-wallet',
    items: [{ path: '/recharge', title: '充值管理', icon: 'el-icon-wallet' }]
  },
  {
    key: 'content',
    title: '运营内容',
    icon: 'el-icon-news',
    items: [
      { path: '/banners', title: '轮播管理', icon: 'el-icon-picture-outline' },
      { path: '/announcements', title: '公告管理', icon: 'el-icon-bell' },
      { path: '/messages', title: '站内信', icon: 'el-icon-message' },
      { path: '/contact', title: '联系我们', icon: 'el-icon-phone-outline' }
    ]
  },
  {
    key: 'system',
    title: '系统设置',
    icon: 'el-icon-setting',
    items: [
      { path: '/trading-settings', title: '交易设置', icon: 'el-icon-time' },
      { path: '/registration-settings', title: '注册设置', icon: 'el-icon-edit-outline' },
      { path: '/app-download', title: '下载APP地址', icon: 'el-icon-download' },
      { path: '/security-questions', title: '找回密码', icon: 'el-icon-key' },
      { path: '/app-versions', title: 'APP 版本', icon: 'el-icon-mobile-phone' },
      { path: '/admin-accounts', title: '管理员账号', icon: 'el-icon-s-custom', superOnly: true }
    ]
  }
]

export function buildMenuGroups(isSuperAdmin) {
  return MENU_GROUPS
    .map(group => ({
      ...group,
      items: group.items.filter(item => !item.superOnly || isSuperAdmin)
    }))
    .filter(group => group.items.length > 0)
}
